import { render, staticRenderFns } from "./UnidadeMedidaLista.vue?vue&type=template&id=5d2317c4&lang=html"
import script from "./UnidadeMedidaLista.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports